<template>
	<div v-if="gnssStatRef.signals">
		<GnssTooltipUpdatedDisplay
			:label="gnssStatRef.gnssName"
			:currentDatetime="gnssStatRef.currentDatetimeBright"
			:valueIsOld="false"
		/>
		<SignalsListDisplay class="signals-list" :signals="gnssStatRef.signals" />
	</div>
</template>
<script lang="ts">
import { toRef } from 'vue';
import type { PropType } from 'vue';

import Consts from '@/api/Consts';

import GnssTooltipUpdatedDisplay from '@/components/map/tooltips/GnssTooltipUpdatedDisplay.vue';
import SignalsListDisplay from '@/components/common/SignalsListDisplay.vue';

import type { GnssStatDisplayItem } from '@/components/map/types/gnssStatsTypes';

export default {
	components: { SignalsListDisplay, GnssTooltipUpdatedDisplay },
	props: {
		gnssStat: {
			type: Object as PropType<GnssStatDisplayItem>,
			required: true,
		},
	},
	setup(props) {
		const gnssStatRef = toRef(props, 'gnssStat');
		return {
			gnssStatRef,
			gray: Consts.COLORS.gray,
		};
	},
}
</script>

<style scoped>
.signals-list {
	font-size: 12px;
	width: 220px;
}
</style>